import React from "react";

const useButtonAnimations = () => {
  const createRipple = button => {
    const ripple = document.createElement("span");
    ripple.classList.add("ripple");

    const size = Math.max(button.clientWidth, button.clientHeight);
    ripple.style.width = ripple.style.height = size + "px";

    ripple.style.left = button.clientWidth / 2 - size / 2 + "px";
    ripple.style.top = button.clientHeight / 2 - size / 2 + "px";

    button.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 1500);
  };

  const createPulse = (button, source) => {
    const pulseEl = document.createElement("div");
    pulseEl.classList.add("pulse");

    // ensure clipping works
    const computedPos = window.getComputedStyle(button).position;
    if (computedPos === "static") {
      button.style.position = "relative";
    }

    button.style.overflow = "hidden";

    // get dynamic border-radius
    const style = window.getComputedStyle(button);
    pulseEl.style.borderRadius =
      source === "editor" ? style.borderRadius : button.querySelector(".dhp-widget-inner").style.borderRadius;

    button.appendChild(pulseEl);

    return pulseEl;
  };

  const createSpinner = button => {
    // ensure positioning
    const computedPos = window.getComputedStyle(button).position;
    if (computedPos === "static") {
      button.style.position = "relative";
    }

    const style = window.getComputedStyle(button);

    const width = button.offsetWidth;
    const height = button.offsetHeight;

    const borderWidth = parseFloat(style.borderWidth) || 0;
    const radius = parseFloat(style.borderTopLeftRadius) || 0;

    // create SVG
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    svg.style.position = "absolute";
    svg.style.top = "0";
    svg.style.left = "0";
    svg.style.width = "100%";
    svg.style.height = "100%";
    svg.style.pointerEvents = "none";
    svg.style.overflow = "visible";
    svg.style.zIndex = "10";

    button.style.overflow = "visible";

    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    svg.setAttribute("preserveAspectRatio", "none");

    // create path
    const path = document.createElementNS("http://www.w3.org/2000/svg", "rect");

    const strokeWidth = borderWidth; // 🔥 match actual border

    // CRITICAL: align exactly on border
    const half = strokeWidth / 2;
    path.setAttribute("x", -half);
    path.setAttribute("y", -half);
    path.setAttribute("width", width + strokeWidth);
    path.setAttribute("height", height + strokeWidth);

    // handle pill shape properly
    const finalRadius = Math.min(radius, height / 2);

    path.setAttribute("rx", finalRadius);
    path.setAttribute("ry", finalRadius);

    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "white");
    path.setAttribute("stroke-width", strokeWidth);

    // runner effect
    const perimeter = 2 * (width + height);
    path.setAttribute("stroke-dasharray", `${perimeter * 0.15} ${perimeter}`);

    path.style.strokeDashoffset = perimeter;
    path.style.animation = "runPath 2s linear infinite";
    path.style.strokeLinecap = "round";

    svg.appendChild(path);
    const target = button.querySelector(".dhp-widget-inner") || button;
    target.appendChild(svg);

    return svg;
  };

  const createPreviewSpinner = button => {
    if (!button) return;

    if (button.querySelector(".button-spinner-svg")) return;

    const computedPos = window.getComputedStyle(button).position;
    if (computedPos === "static") {
      button.style.position = "relative";
    }

    // IMPORTANT FIX
    const target = button.querySelector(".dhp-widget-inner") || button;

    const style = window.getComputedStyle(target);

    const width = target.offsetWidth;
    const height = target.offsetHeight;

    const borderWidth = parseFloat(style.borderTopWidth) || parseFloat(style.borderWidth) || 2;

    // NOW radius will be correct
    const radius = parseFloat(style.borderTopLeftRadius) || 0;

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    svg.classList.add("button-spinner-svg");

    svg.style.position = "absolute";
    svg.style.top = "0";
    svg.style.left = "0";
    svg.style.width = "100%";
    svg.style.height = "100%";
    svg.style.pointerEvents = "none";

    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    svg.setAttribute("preserveAspectRatio", "none");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "rect");

    path.setAttribute("x", borderWidth / 2);
    path.setAttribute("y", borderWidth / 2);
    path.setAttribute("width", width - borderWidth);
    path.setAttribute("height", height - borderWidth);

    const finalRadius = Math.min(radius, height / 2);

    path.setAttribute("rx", finalRadius);
    path.setAttribute("ry", finalRadius);

    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "white");
    path.setAttribute("stroke-width", borderWidth);

    const perimeter = 2 * (width + height);

    path.setAttribute("stroke-dasharray", `${perimeter * 0.15} ${perimeter}`);
    path.style.strokeDashoffset = perimeter;
    path.style.strokeLinecap = "round";
    path.style.animation = "runPath 2s linear infinite";

    svg.appendChild(path);
    button.appendChild(svg);

    return svg;
  };

  return {
    createRipple,
    createPulse,
    createSpinner,
    createPreviewSpinner,
  };
};

export default useButtonAnimations;
